import React from 'react';
import { Check, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function PricingCard({ plan, ctaHref = '/contact' }) {
  return (
    <div
      className={`relative rounded-2xl p-7 transition-all duration-300 ${
        plan.highlight
          ? 'bg-gradient-to-b from-[#0d0a1f] via-[#1c1138] to-[#2a1645] text-white border border-violet-500/30 shadow-2xl shadow-violet-500/10 scale-[1.02]'
          : 'bg-white text-slate-900 border border-slate-200 hover:border-violet-300 hover:shadow-xl'
      }`}
    >
      {plan.highlight && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 bg-violet-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow">
          <Sparkles size={12} /> {plan.badge || 'Most Popular'}
        </span>
      )}
      <p className={`text-xs font-bold tracking-widest mb-1 ${plan.highlight ? 'text-violet-300' : 'text-violet-600'}`}>{plan.name}</p>
      {!plan.highlight && plan.badge && (
        <p className="text-xs text-slate-500 mb-3">{plan.badge}</p>
      )}
      <div className="flex items-baseline gap-1 my-3">
        <span className={`text-4xl font-extrabold ${plan.highlight ? 'text-white' : 'text-slate-900'}`}>{plan.price}</span>
        <span className={plan.highlight ? 'text-violet-200/80' : 'text-slate-500'}>/monthly</span>
      </div>
      <p className={`text-sm mb-5 ${plan.highlight ? 'text-violet-100/80' : 'text-slate-500'}`}>{plan.feature}</p>
      <ul className="space-y-2.5 mb-7">
        {plan.items.map((it) => (
          <li key={it} className="flex items-start gap-2 text-sm">
            <Check size={16} className={`mt-0.5 ${plan.highlight ? 'text-violet-300' : 'text-violet-600'}`} />
            <span className={plan.highlight ? 'text-slate-200' : 'text-slate-700'}>{it}</span>
          </li>
        ))}
      </ul>
      <Link
        to={ctaHref}
        className={`block text-center font-semibold rounded-full py-3 transition-all ${
          plan.highlight
            ? 'bg-violet-500 hover:bg-violet-400 text-white'
            : 'bg-slate-900 hover:bg-violet-600 text-white'
        }`}
      >
        Enquire Now
      </Link>
    </div>
  );
}
